import React, { FC } from 'react'
import { Route, Switch } from 'react-router-dom'
import ProtectedRoute from '../components/ProtectedRoute'
import { AccessDenied } from '../layout/AccessDenied'
import { Layout } from '../layout/Layout'
import { Login } from '../layout/Login'
import { Logout } from '../layout/Logout'
import { NotFound } from '../layout/NotFound'
import { routes } from './Routes'

export const AppRouter: FC<{}> = () => {
  return (
    <Switch>
      <Route key={'/login'} exact path={'/login'} component={Login} />
      {routes.map(({ path, title, content, permissions }) => (
        <ProtectedRoute key={path} exact={path === '/'} path={path} permissions={permissions} Component={() => <Layout title={title} Component={content} />} />
      ))}
      <Route key={'/logout'} exact path={'/logout'} component={Logout} />
      <Route key={'/accessdenied'} exact path={'/accessdenied'} component={AccessDenied} />
      <Route component={NotFound} />
    </Switch>
  )
}

export function useNav(history: any) {
  const path = history.location.pathname
  const setPath = (path: string) => history.push(path)
  return [path, setPath]
}
